export default {"src":"/_next/static/image/public/images/report-progress.003cc4e4a4618174958c204a85e401bb.svg","height":21,"width":18};